const portal = {
  state: {
    profile: '',
    title: '',
    homeLogo: '',
    homeBg: ''
  },
  mutations: {
    setPortalInfo (state, {profile, title, homeLogo, homeBg}) {
      state.profile = profile
      state.title = title
      state.homeLogo = homeLogo
      state.homeBg = homeBg
      if (title) {
        document.title = title
      }
    }
  }
}

export default portal
